
/**
 * Internal dependencies
 */
import {
    WEB_PLANS_RECEIVE,
    WEB_PLANS_REQUEST,
    WEB_PLANS_REQUEST_SUCCESS,
    WEB_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllWebPlans, requestingWebPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeWeb [description]
 * @return {[type]}                  [description]
 */
export const requestWebPlans = () => (dispatch) => {
    dispatch({
        type: WEB_PLANS_REQUEST
    });
    return cscom.webPlan().list()
        .then(webPlans => {
            dispatch({ type: WEB_PLANS_REQUEST_SUCCESS });
            dispatch({ type: WEB_PLANS_RECEIVE, payload: { items: webPlans } });
            return webPlans;
        })
        .catch((error) => {
            dispatch({ type: WEB_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllWebPlans(getState());
	const requesting = requestingWebPlans(getState());

	if (plans.length === 0 && requesting === false) {
		return dispatch(requestWebPlans(...props))
	}

	return plans;
}